import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

const getCardSize = (
  type:
    | 'visa'
    | 'mastercard'
    | 'discover'
    | 'JCB'
    | 'diners'
    | 'apple'
    | 'google'
) => {
  switch (type) {
    case 'visa':
      return `
        width: 32px;
        height: 10px;
      `
    case 'mastercard':
      return `
        width: 26px;
        height: 16px;
      `
    case 'discover':
      return `
        width: 32px;
        height: 10px;
      `
    case 'JCB':
      return `
        width: 22px;
        height: 10px;
      `
    case 'diners':
      return `
        width: 24px;
        height: 10px;
      `
    default:
      return ``
  }
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 33.5px 24px;
  width: 100%;
  background: ${colors.white};
  border-radius: 4px;
  margin-bottom: 16px;
`

export const CartDeliveriesWrapper = styled.div`
  padding: 9.5px 0 11.5px 0;
  margin-bottom: 0;
`

export const WrapperDivMargin = styled.div`
  margin-bottom: 13px;
`
export const CardsImgWraper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media ${device.mobileMax} {
    flex-wrap: wrap;
    justify-content: start;
    row-gap: 8px;
  }
`

export const RadioLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media ${device.mobileMax} {
    flex-direction: column;
    ${CardsImgWraper} {
      margin-top: 5px;
    }
  }
`

export const StyledSpan = styled.span<{ isInner?: boolean }>`
  font-size: ${({ isInner }) => (isInner ? 14 : 18)}px;
  margin-right: 32px;
  display: flex;
  align-items: center;
  color: ${colors.mainText};
  line-height: 27px;
  font-weight: 400;
  white-space: break-spaces;
`

export const StyledImgWrapper = styled.div`
  width: 120px;
`

export const CardImg = styled.img<{
  type:
    | 'visa'
    | 'mastercard'
    | 'discover'
    | 'JCB'
    | 'diners'
    | 'apple'
    | 'google'
}>`
  display: flex;
  align-items: center;
  padding: 4px;
  width: 40px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-right: 8px;
  ${({ type }) => getCardSize(type)}
  width: 40px;
  height: 24px;
`

export const VisaWraper = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 24px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-right: 8px;
  & img {
    width: 32px;
    height: 10px;
  }
`
export const MasterCardWraper = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 24px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-right: 8px;
  & img {
    width: 26px;
    height: 16px;
  }
`
export const DiscoverWraper = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 24px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-right: 8px;
  & img {
    width: 32px;
    height: 10px;
  }
`

export const JCBWraper = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 24px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  margin-right: 8px;
  & img {
    width: 22px;
    height: 16px;
  }
`

export const DinersWraper = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 24px;
  border: 1px solid #eeeeee;
  border-radius: 2px;
  & img {
    width: 24px;
    height: 16px;
  }
`

export const Label = styled.label`
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${colors.mainText};
`

export const InputContainerForBluesnap = styled.div`
  flex: 1;
  height: 47px;
  border: 1px solid ${colors.greyStroke};
  border-radius: 8px;
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  height: 76px;
  flex: 1;
`

export const Input = styled.input`
  padding: 13px 16px;
  flex: 1;
  height: 47px;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.mainText};
  border: 1px solid ${colors.greyStroke};
  border-radius: 8px;
  outline: none;

  &::placeholder {
    color: ${colors.greyTextWhiteBg};
    opacity: 1;
  }
  &:-ms-input-placeholder {
    color: ${colors.greyTextWhiteBg};
  }
  &::-ms-input-placeholder {
    color: ${colors.greyTextWhiteBg};
  }
`
export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
`

export const RowDivider = styled.div`
  width: 16px;
`

export const PaypalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export const BuyNowPayLater = styled.span`
  margin-top: 8px;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${colors.black};
`
